import { httpRequest } from "@services/http";
import { Ad } from "@models/Ad.model";

/*
    Rename an ad for the campaign it was selected into (MPN-1508).

    Its own endpoint rather than the general ad PATCH: that one also carries content and
    template flags, and retitling has to be reachable by engagement users who should not gain
    those along with it.

    The name is display only. The link back to the original template is a database reference
    (`source_template`), so renaming cannot affect template-level reporting.
*/
export class CommandRetitleAd {
  async run(adId: number, name: string): Promise<Ad> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/${adId}/title/`;
    const response = await httpRequest<Ad>(url, { method: "PATCH", body: { name } });
    return new Ad(response);
  }
}
